import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

const gltfLoader = new GLTFLoader();

const getGLTF = async (path) => {
    const [gltf] = await Promise.all([
        gltfLoader.loadAsync(path),
    ]);
    return gltf;
}

export default getGLTF;
